import React from 'react';

import { COUNTRY_KEY } from '#/utils';
import { FilterRenderer } from '.';
import { CountryFilter } from './GeoFilters';

const MainFilterBlock = ({ filters, queryParams, handleFilterChange, setQueryParams, addCompany }) => {
    const regions = queryParams.region || [];
    const countries = queryParams.country || [];

    const handleCountryChange = val => {
        handleFilterChange(COUNTRY_KEY, val);
    };

    const getFilterChangeHandler = filterName => {
        return function (val) {
            handleFilterChange(filterName, val);
        };
    };

    const renderFilter = filter => {
        if (filter.name === COUNTRY_KEY) {
            return (
                <CountryFilter
                    key={COUNTRY_KEY}
                    regions={regions}
                    selected={countries}
                    onChange={handleCountryChange}
                />
            );
        }

        return (
            <FilterRenderer
                key={filter.name}
                filter={filter}
                queryParams={queryParams}
                onChange={getFilterChangeHandler(filter.name)}
                setQueryParams={setQueryParams}
                addCompany={addCompany}
            />
        );
    };

    return <div className='flex flex-wrap gap-4 items-center'>{filters?.map(renderFilter)}</div>;
};

export { MainFilterBlock };
